export enum PatientTypeEnum {
  New = 'new',
  Existing = 'existing',
}
export const PATIENT_TYPE_TO_BACKEND: Record<PatientTypeEnum, 'new_patient' | 'returning_patient'> = {
  [PatientTypeEnum.New]: 'new_patient',
  [PatientTypeEnum.Existing]: 'returning_patient',
};

export interface AppointmentData {
  treatment: string;
  patientType: PatientTypeEnum;
  personalDetails: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    dateOfBirth?: string;
    address?: string;
  };
  selectedSlot: string | null;
}

export interface TimeSlot {
  time: string;
  available: boolean;
}

export interface DateSlot {
  date: string;
  dayName: string;
  dayNumber: number;
  month: string;
  year: number;
  slots: TimeSlot[];
}

export interface Practice {
   id: string;
  title: string;
  address?: string
  email?: string;
  logo?: string;
  phone_number?: string;
  promote_primetime: boolean;
  website?: string;
  working_hours?: WorkingHours;
  appointment_types?: AppointmentType[];
  tenant_id: string
}

export interface AuthState {
  token: string | null;
  practice: Practice | null;
  loading: boolean;
  error: string | null;
}

interface WorkingHour {
  day: 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';
  open: string;
  hours: number;
}
type WorkingHours = WorkingHour[];
export interface InitPracticeResponse {
  token: string;
  practice: {
    id: string;
    title: string;
    address?: string
    email?: string;
    logo?: string;
    phone_number?: string;
    promote_primetime: boolean;
    website?: string;
    working_hours?: WorkingHours;
    appointment_types?: AppointmentType[];
    tenant_id: string
  };
}

export interface AppointmentTypeProviderAttributes {
  user_id: number;
  tenant_id: number;
  pms_provider_id: string;
  role: string;
  manager: boolean;
  data_provider_id: string;
  first_name: string;
  last_name: string;
  data_provider_type: string;
}

export interface AppointmentTypeProvider {
  id: string;
  type: 'provider';
  attributes: AppointmentTypeProviderAttributes;
}

export interface AppointmentTypeAttributes {
  title: string;
  slug?: string;
  treatment_codes: string[];
  new_patient_minutes: number;
  existing_patient_minutes: number;
  provider: { data: AppointmentTypeProvider };
}

export interface AppointmentTypeItem {
  id: string;
  type: 'appointment_type';
  attributes: AppointmentTypeAttributes;
}

export interface AppointmentType {
  id: string;
  title: string;
  slug?: string;
  treatmentCodes: string[];
  newPatientMinutes: number;
  existingPatientMinutes: number;
  provider: {
    id: string;
    firstName: string;
    lastName: string;
    role: string;
    pmsProviderId: string;
  };
}